import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type DrawerState = {
  drawerOpen: boolean;
  isSmallScreen: boolean;
};

type DrawerActions = {
  setDrawerOpen: (open: boolean) => void;
  toggleDrawerOpen: () => void;
  setIsSmallScreen: (isSmall: boolean) => void;
};

const initialState: DrawerState = {
  drawerOpen: false,
  isSmallScreen: false,
};

export const createDrawerSlice: WaterlyAppStateCreator<DrawerActions, DrawerState> = (set, get) => ({
  ...initialState,
  setDrawerOpen: (open) => {
    set({ drawerOpen: open });
  },
  toggleDrawerOpen: () => {
    const { drawerOpen } = get();
    set({ drawerOpen: !drawerOpen });
  },
  // this is for responsive behavior and is called when the media query changes
  setIsSmallScreen: (isSmall) => {
    const { isSmallScreen, drawerOpen } = get();
    const nextDrawerOpen = !isSmall;
    // If screen size changed
    if (isSmall !== isSmallScreen || drawerOpen !== nextDrawerOpen) {
      set({
        isSmallScreen: isSmall,
        // When transitioning to small screen, close drawer
        // When transitioning to large screen, open drawer
        drawerOpen: nextDrawerOpen,
      });
    }
  },
});
